module.exports = __webpack_public_path__ + "d772f8b6bbc0b998997e856d8711c098.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/googley-18.png
// module id = 2111
// module chunks = 0